import { useCallback, useEffect, useMemo, useState } from "react";

/** Which rows of a list are ticked; a row that leaves the list (another page, a filter) is dropped from the selection */
export function useRowSelection(ids: string[]) {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const key = ids.join(",");
  useEffect(() => {
    setSelected((cur) => {
      const on = new Set(ids);
      const next = new Set([...cur].filter((i) => on.has(i)));
      return next.size === cur.size ? cur : next;
    });
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = useCallback((id: string) => setSelected((cur) => (cur.has(id) ? new Set([...cur].filter((x) => x !== id)) : new Set(cur).add(id))), []);
  const allOn = ids.length > 0 && ids.every((i) => selected.has(i));
  const toggleAll = useCallback(() => setSelected(allOn ? new Set() : new Set(ids)), [allOn, key]); // eslint-disable-line react-hooks/exhaustive-deps
  const clear = useCallback(() => setSelected(new Set()), []);
  return useMemo(() => ({ selected, ids: [...selected], count: selected.size, toggle, toggleAll, allOn, clear }), [selected, toggle, toggleAll, allOn, clear]);
}
